import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BpcCreditNoteTabs from '@accounting/components/tabs/credit-notes/credit-note-tabs.vue';

@Component({
  name: 'bpc-credit-note',
  components: {
    'bpc-credit-note-tabs': BpcCreditNoteTabs,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class CreditNotes extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
